var exports = {
  "N_": "Link__ezRZ0y",
  "az": "Box__EYbgCz",
  "DZ": "Heading__NEmWYD",
  "Ot": "PredicateType__tig8si",
  "wy": "Box_1__kon5JX",
  "EY": "Text__xeQzJ9",
  "pv": "Box_2__CyBg-U",
  "UE": "Text_1__fqdzOW",
  "w9": "Box_3__wEooYL",
  "pQ": "Box_4__ttns2a",
  "bx": "Link_1__YeqFPH",
  "iu": "Link_2__1fsxBJ",
  "ws": "Box_5__fOUavl",
  "do": "Heading_1__VHkhEa",
  "ZN": "SubjectDigest__1XxAiZ",
};

module.exports = exports;
